module.exports = {
	"_args": [
		[
			"@truffle/contract-schema@3.0.19",
			"/vercel/path0"
		]
	],
	"_from": "@truffle/contract-schema@3.0.19",
	"_id": "@truffle/contract-schema@3.0.19",
	"_inBundle": false,
	"_integrity": "sha512-0fT3gBwJPCxO/B+k/xel8aKEGfvXm0nJ965KpCPEC6dpl+XHewJx6TZufiVmxuKTpOAytNfO/aDkQ8sjXs47Fw==",
	"_location": "/@truffle/contract/@truffle/contract-schema",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "@truffle/contract-schema@3.0.19",
		"name": "@truffle/contract-schema",
		"escapedName": "@truffle%2fcontract-schema",
		"scope": "@truffle",
		"rawSpec": "3.0.19",
		"saveSpec": null,
		"fetchSpec": "3.0.19"
	},
	"_requiredBy": [
		"/@truffle/contract"
	],
	"_resolved": "https://registry.npmjs.org/@truffle/contract-schema/-/contract-schema-3.0.19.tgz",
	"_spec": "3.0.19",
	"_where": "/vercel/path0",
	"author": {
		"name": "Tim Coulter",
		"email": "tim@trufflesuite.com"
	},
	"bugs": {
		"url": "https://github.com/trufflesuite/truffle/issues"
	},
	"dependencies": {
		"ajv": "^6.10.0",
		"crypto-js": "^3.1.9-1",
		"debug": "^4.1.0"
	},
	"description": "JSON schema for contract artifacts",
	"devDependencies": {
		"json-schema-to-typescript": "^5.5.0",
		"mocha": "5.2.0",
		"solc": "0.5.12"
	},
	"directories": {
		"spec": "./spec"
	},
	"gitHead": "a962a994179f561ec8862abed747b18958dbf6ba",
	"homepage": "https://github.com/trufflesuite/truffle/tree/master/packages/contract-schema#readme",
	"keywords": [
		"ethereum",
		"json",
		"schema",
		"contract",
		"artifacts"
	],
	"license": "MIT",
	"main": "index.js",
	"name": "@truffle/contract-schema",
	"publishConfig": {
		"access": "public"
	},
	"repository": {
		"type": "git",
		"url": "https://github.com/trufflesuite/truffle/tree/master/packages/contract-schema"
	},
	"scripts": {
		"build": "./scripts/generate-declarations",
		"prepare": "yarn run build",
		"test": "mocha"
	},
	"typings": "./typings/index.d.ts",
	"version": "3.0.19"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@truffle/contract/node_modules/@truffle/contract-schema/package.json
// module id = 1380
// module chunks = 0